import React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import './style.scss';

export default ({
  loading = false,
  position = 'centered',
  backgroundColor = '#ccc',
  color = '#363636',
  ...additionalProps
}) => (
  <SpinnerComponent
    loading={loading}
    position={position}
    backgroundColor={backgroundColor}
    color={color}
    {...additionalProps}
  />
);
